<template>
  <div>
    <main class="main">
      <TopSliderHome />
      <HomeCategoreis />
      <FreeShippingProducts/>
      <!-- <falties /> -->
      <VipSection />
      <homeProductSlider
        titleBox="جدید ترین های آیلند"
        sliderId="new-products"
        typeSlider="new-products"
      >
      </homeProductSlider>
      <!-- <specialBanner /> -->
      <homeProductSlider
        titleBox="تخفیف دارهای آیلند"
        sliderId="most-discounts"
        typeSlider="most-discounts"
      >
      </homeProductSlider>
      <!-- <section class="container banners  box-banners">
        <banner
          :data="{
            link: '/products/category/3/لباس-خواب-ساتن-زنانه?category_id=3',
            new_tab: 1,
            picture: addressBanner3,
          }"
        />
        <banner
          :data="{
            link: '/products/category/5/تاپ-شلوار-زنانه?sort=newest&category_id=5',
            new_tab: 1,
            picture: addressBanner4,
          }"
        />
      </section> -->
      <homeProductSlider
        titleBox="پیشنهادی های آیلند"
        sliderId="suggestions"
        typeSlider="suggestions"
      >
      </homeProductSlider>
      <!-- <section class="container banners ">
        <banner
          :data="{
            link: '/products/category/11/پیراهن-و-ست-های-فانتزی?category_id=11',
            new_tab: 1,
            picture: addressBanner2,
          }"
        />
      </section> -->
      
      <homeProductSlider
        titleBox="محصولات ایراد دار آیلند"
        sliderId="falties"
        typeSlider="falties"
        :mainList="Falties"
      >
      </homeProductSlider>
      

      <homeProductSlider
        titleBox="پرفروشترین های آیلند"
        sliderId="most-sales"
        typeSlider="most-sales"
      >
      </homeProductSlider>
      <Banners :banners="banners[0]"></Banners>
      <Flashes
        v-if="
          $store.getters['front/getHomeData'] != null &&
            $store.getters['front/getHomeData'].flashes != ''
        "
        :flashes="$store.getters['front/getHomeData'].flashes"
      />
      <Banners :banners="banners[1]"></Banners>
      <Weblogs></Weblogs>
    </main>
    <div id="mainSpinner">
      <div
        v-if="!$store.getters['front/getHomeData']"
        class="fulfilling-bouncing-circle-spinner"
      >
        <div class="circle"></div>
        <div class="orbit"></div>
      </div>
    </div>
  </div>
</template>

<script>
import TopSliderHome from "../components/shared/TopSliderHome.vue";
import FreeShippingProducts from "../components/FreeShippingProducts.vue";
import baner1 from "../../../assets/images/iland/Capt2ure2.jpg";
import baner2 from "../../../assets/images/down_slider_main.jpg";
import baner3 from "../../../assets/images/test/banner_main2.jpg"
import baner4 from "../../../assets/images/test/banner_main1.jpg"
import baner5 from "../../../assets/images/test/baner5.png";
import baner6 from "../../../assets/images/test/baner6.png";
import baner7 from "../../../assets/images/test/baner7.png";
import HomeCategoreis from "@/parts/Front/components/HomeCategoreis/index.vue";
import VipSection from "@/parts/Front/components/VipSection";
import homeProductSlider from "@/parts/Front/components/homeProductSlider";
import Banners from "@/parts/Front/components/Banners";
import banner from "@/parts/Front/components/banner/index.vue";
import specialBanner from "@/parts/Front/components/banner/specialBanner.vue";
import Flashes from "@/parts/Front/components/FlashProducts";
import Weblogs from "@/parts/Front/components/Weblogs";
import SearchSection from "@/parts/Front/components/SearchSection";
import ScrollToTop from "@/parts/Front/components/ScrollToTop";
import debounce from "lodash/debounce";
export default {
  name: "Home",
  components: {
    // FourBanners,
    banner,
    VipSection,
    homeProductSlider,
    // RecommendedProduct,
    Banners,
    Flashes,
    Weblogs,
    SearchSection,
    // LastInstaPosts,
    ScrollToTop,
    HomeCategoreis,
    TopSliderHome,
    specialBanner,
    FreeShippingProducts,
    
  },
  data() {
    return {
      showInstagram: true,
      addressBanner1: baner1,
      addressBanner2: baner2,
      addressBanner3: baner3,
      addressBanner4: baner4,
      addressBanner5: baner5,
      addressBanner6: baner6,
      addressBanner7: baner7,
      reRenderInstagramFunction: debounce(this.reRenderInstagram, 250),
    };
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.reRenderInstagramFunction);
  },
  mounted() {
    window.removeEventListener("resize", this.reRenderInstagramFunction);
    window.addEventListener("resize", this.reRenderInstagramFunction);
  },
  created() {
    this.$store.dispatch("front/getHomeDataFromServer", {
      $root: this.$root,
    });
  },
  methods: {
    reRenderInstagram() {
      this.showInstagram = false;
      this.$nextTick(() => {
        this.showInstagram = true;
      });
    },
  },
  computed: {
    Falties(){
      return this.$store.getters["front/getFalties"];
    },
    banners() {
      if (this.$store.getters["front/getHomeData"] != null) {
        let advertise = this.$store.getters["front/getHomeData"].advertise;
        return [
          [advertise.position1, advertise.position2],
          [advertise.position3, advertise.position4],
        ];
      } else {
        return [
          [null, null],
          [null, null],
        ];
      }
    },
  },
};
</script>
<style scoped>
.box-banners {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}

.banners {
  padding-top: 60px;
}

@media screen and (max-width: 639px) {
  .box-banners {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .banners {
    padding-top: 40px;
  }
}
</style>
